import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { aeChoices } from "../config-generics/aeKao";
import { signatureConfig } from "../config-generics/signature";

export const confirmationConfig: PageConfig[] = [
  {
    name: "confirmation",
    title: "Kī Taurangi - Declaration",
    questions: [
      {
        type: "radiogroup",
        name: "mediaStatement",
        title: `
            During our wānanga, we will be taking photos and videos which may be
            shared on our pānui, website and/or our social media platforms. By
            agreeing with this statement, you give permission for Rangitāne o
            Wairau to share these photos or videos that may contain images of
            all those noted on this registration form.
        `,
        choices: aeChoices,
        isRequired: true,
      },
    ],
  },
  {
    name: "infoUsage",
    title: "How Your Information Will Be Used",
    elements: [
      {
        type: "html",
        html: `
          <p>
            The information you provide on this form is being collected for the
            purpose of registering you for this event and for managing event
            logistics, communications, and follow-up activities.
          </p>
          <p>
            Your personal information will be handled in accordance with the
            Privacy Act 2020, which governs how personal data is collected,
            stored, used, and shared. It may be shared with event partners (such
            as funding partners) only where necessary for the delivery of the
            event or to meet our reporting and accountability obligations.
          </p>
          <p>
            Information collected will also form part of our organisational
            records and will be securely managed and retained in line with our
            record-keeping and privacy practices.
          </p>
          <p>
            You have the right to access and request correction of any personal
            information we hold about you. To do so, or if you have any other
            queries regarding your personal information, please contact us at
            <a href="mailto:admin@rangitane.org.nz" target="_blank">
              admin@rangitane.org.nz
            </a>
          </p>
        `,
      },
    ],
  },
  {
    name: "confirmation",
    title: "Kī Taurangi - Declaration",
    questions: [
      {
        type: "radiogroup",
        name: "correct",
        title:
          "I/we confirm that the information provided is true and correct.",
        choices: aeChoices,
        isRequired: true,
      },
      signatureConfig[0].questions[0],
    ],
  },
];
